import React, { useEffect, useState } from 'react'

// components
import OutlineButton from 'components/Button/OutlineButton'
import GradientButton from 'components/Button/GradientButton'
import PlusIcon from 'assets/icons/plus-icon-8x8.svg?component'
import MinusIcon from 'assets/icons/minus-icon-8x8.svg?component'
import CloseIcon from 'assets/icons/close-white-13x13.svg?component'

// json
import AvailabilityList from 'assets/json/explore/availability.json'
import MarketList from 'assets/json/explore/market.json'
import MediumList from 'assets/json/explore/medium.json'
import CategoryList from 'assets/json/popular-category.json'

// styles
import styles from './index.module.scss'

const MobileNFTFilter = props => {
  const { exploreType, category, availability, medium, market, onClose, onFilter } = props

  const [selectedAvailability, setSelectedAvailability] = useState<any>(availability)
  const [selectedMarket, setSelectedMarket] = useState<any>(market)
  const [selectedMedium, setSelectedMedium] = useState<any>(medium)
  const [categoryList, setCategoryList] = useState<any[]>([])
  const [showListingType, setShowListingType] = useState(false)
  const [showMediumType, setShowMediumType] = useState(false)
  const [showCategoryType, setShowCategoryType] = useState(false)
  const [showListedBy, setShowListedBy] = useState(false)

  useEffect(() => {
    if (category.length > 0) {
      setCategoryList(category)
      return
    }
    let array: any[] = []
    CategoryList.map(item => {
      let object: any = item
      object.checked = false
      array.push(object)
    })
    setCategoryList(array)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSelectCategory = index => {
    let array = [...categoryList]
    array[index].checked = !array[index].checked
    setCategoryList(array)
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.headerTitle}>Filters</div>
          <div className="w-[35px] h-[35px] flex items-center justify-center" onClick={() => onClose()}>
            <CloseIcon />
          </div>
        </div>

        <div className="g-container">
          {/* Listing Status */}
          {exploreType === 0 && (
            <div className="w-full mt-[30px]">
              <div
                className="w-full flex justify-between items-start gap-[15px]"
                onClick={() => setShowListingType(!showListingType)}
              >
                <div className={`${styles.showListing}`}>Listing Status</div>
                <div className="w-[16px] h-[16px] flex items-center justify-center">
                  {showListingType ? <MinusIcon /> : <PlusIcon />}
                </div>
              </div>

              <div className={styles.descBorder} />

              {showListingType && (
                <div className="mt-15px">
                  {AvailabilityList.map((item, index) => (
                    <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                      <label
                        className={`${styles.checkmark}`}
                        onClick={() => {
                          setSelectedAvailability(item)
                        }}
                      >
                        {item.label}
                      </label>
                      <input
                        className={`${styles.checkbox}`}
                        type="checkbox"
                        id={item.id}
                        checked={selectedAvailability.value == item.value}
                        onChange={() => {
                          setSelectedAvailability(item)
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Listed By */}
          {exploreType === 0 && (
            <div className="w-full mt-[30px]">
              <div
                className="w-full flex justify-between items-start gap-[15px]"
                onClick={() => setShowListedBy(!showListedBy)}
              >
                <div className={`${styles.showListing}`}>Listed By</div>
                <div className="w-[16px] h-[16px] flex items-center justify-center">
                  {showListedBy ? <MinusIcon /> : <PlusIcon />}
                </div>
              </div>

              <div className={styles.descBorder} />

              {showListedBy && (
                <div className="mt-15px">
                  {MarketList.map((item, index) => (
                    <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                      <label
                        className={`${styles.checkmark}`}
                        onClick={() => {
                          setSelectedMarket(item)
                        }}
                      >
                        {item.label}
                      </label>
                      <input
                        className={`${styles.checkbox}`}
                        type="checkbox"
                        id={item.id}
                        checked={selectedMarket.value == item.value}
                        onChange={() => {
                          setSelectedMarket(item)
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Medium Status */}
          {exploreType === 0 && (
            <div className="w-full mt-[30px]">
              <div
                className="w-full flex justify-between items-start gap-[15px]"
                onClick={() => setShowMediumType(!showMediumType)}
              >
                <div className={`${styles.showListing}`}>Medium</div>
                <div className="w-[16px] h-[16px] flex items-center justify-center">
                  {showMediumType ? <MinusIcon /> : <PlusIcon />}
                </div>
              </div>

              <div className={styles.descBorder} />

              {showMediumType && (
                <div className="mt-15px">
                  {MediumList.map((item, index) => (
                    <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                      <label
                        className={`${styles.checkmark}`}
                        onClick={() => {
                          setSelectedMedium(item)
                        }}
                      >
                        {item.label}
                      </label>
                      <input
                        className={`${styles.checkbox}`}
                        type="checkbox"
                        id={item.id}
                        checked={selectedMedium === item}
                        onChange={() => {
                          setSelectedMedium(item)
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Categories Status */}
          <div className="w-full mt-[30px] mb-[100px]">
            <div
              className="w-full flex justify-between items-start gap-[15px]"
              onClick={() => setShowCategoryType(!showCategoryType)}
            >
              <div className={`${styles.showListing}`}>Categories</div>
              <div className="w-[16px] h-[16px] flex items-center justify-center">
                {showCategoryType ? <MinusIcon /> : <PlusIcon />}
              </div>
            </div>

            <div className={styles.descBorder} />

            {showCategoryType && (
              <div className="mt-15px">
                {categoryList.map((item, index) => (
                  <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                    <label
                      className={`${styles.checkmark}`}
                      onClick={() => {
                        handleSelectCategory(item)
                      }}
                    >
                      {item.name}
                    </label>
                    <input
                      className={`${styles.checkbox}`}
                      type="checkbox"
                      id={item.id}
                      checked={item.checked}
                      onChange={() => {
                        handleSelectCategory(index)
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* <Disclosure defaultOpen={true}>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between items-center">
                <div className={`${styles.subTitle} mt-[12px] mb-[12px]`}>Availability</div>
                <DownArrowIcon className={`${open ? 'rotate-180 transform' : ''} mt-1 mr-1`} />
              </Disclosure.Button>
              <Disclosure.Panel>
                <Radio
                  data={AvailabilityList}
                  selected={selectedAvailability}
                  onChange={item => setSelectedAvailability(item)}
                />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure> */}

        {/* <Disclosure defaultOpen={true}>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between items-center">
                <div className={`${styles.subTitle} mt-[12px] mb-[12px]`}>Market</div>
                <DownArrowIcon className={`${open ? 'rotate-180 transform' : ''} mt-1 mr-1`} />
              </Disclosure.Button>
              <Disclosure.Panel>
                <Radio data={MarketList} selected={selectedMarket} onChange={item => setSelectedMarket(item)} />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure> */}

        {/* <Disclosure defaultOpen={true}>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between items-center">
                <div className={`${styles.subTitle} mt-[12px] mb-[12px]`}>Medium</div>
                <DownArrowIcon className={`${open ? 'rotate-180 transform' : ''} mt-1 mr-1`} />
              </Disclosure.Button>
              <Disclosure.Panel>
                <Radio data={MediumList} selected={selectedMedium} onChange={item => setSelectedMedium(item)} />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure> */}

        {/* <Disclosure defaultOpen={true}>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between items-center">
                <div className={`${styles.subTitle} mt-[12px] mb-[24px]`}>Categories</div>
                <DownArrowIcon className={`${open ? 'rotate-180 transform' : ''} mt-1 mr-1`} />
              </Disclosure.Button>
              <Disclosure.Panel>
                {categoryList.length !== 0 && (
                  <Checkbox categoryList={categoryList} onChange={index => handleSelectCategory(index)} />
                )}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure> */}
      </div>
      <div className={styles.bottomArea}>
        <div className="w-[94px]">
          <OutlineButton
            label="Cancel"
            onClick={() => onClose()}
            color="var(--text-gray-200-color)"
            borderWidth={2}
            borderColor="rgba(var(--main-bg-color-rgb), 0.1)"
            fullWidth
          />
        </div>
        <div className="w-[94px]">
          <GradientButton
            label="Apply"
            backgroundColor01="var(--main-icon-color)"
            backgroundColor02="var(--main-icon-color)"
            color="var(--background-main-color)"
            onClick={() =>
              onFilter({
                category: categoryList,
                availability: selectedAvailability,
                medium: selectedMedium,
                market: selectedMarket,
              })
            }
            fullWidth
          />
        </div>
      </div>
    </div>
  )
}

export default MobileNFTFilter
